import { computed } from "vue";
import { useRoute } from "vue-router";

import type { RouteLocationRaw } from "vue-router";

export interface InboxTabItem {
  label: string;
  link: RouteLocationRaw;
}

export const useInbox = () => {
  const route = useRoute();

  const isItemActive = ({
    item,
    isGlobalView,
  }: {
    item: InboxTabItem;
    isGlobalView: boolean;
  }): boolean => {
    if (typeof item.link !== "object" || !("query" in item.link)) {
      return false;
    }

    const linkQuery = item.link.query || {};

    if (isGlobalView && !!route.query.type) {
      return false;
    }

    return Object.entries(linkQuery).every(
      ([key, value]) => route.query[key] === value
    );
  };

  const inboxAllActivityActive = computed(() => {
    return !route.query.type;
  });
  return {
    isItemActive,
    inboxAllActivityActive,
  };
};
